module.exports = __webpack_public_path__ + "static/the-outsiders-bb736a4ceb7d5b584da3f0fdb79a67b6.jpg";